// extracted by mini-css-extract-plugin
export default {"form":"C_4rIvSrWEFUr75rXtk7","emailButton":"bJXpuKgoLtQJrNKrfZ3q","banner":"wOsJp_8Z98jpnjoG3hqf","modalTabs":"Isi1xy2kidvzO9GfSg2v"};